// import React, { useState } from 'react';
// import Popup from '../../../../components/common/NewPopup/Popup';
// import { Box, Icon, Typography } from '@mui/material';
// import { Common } from '../../../../components/common/Common';
import useStyles from './styles';

// const DeleteQuestionApi = (props) => {
//   const { handleNo, handleYes, openDeletePopup, setOpenDeletePopup } = props;
//   const classes = useStyles();
//   console.log('log11');

//   return (
//     <Popup openPopup={true} setOpenPopup={setOpenDeletePopup} maxWidth="sm">
//       <Box className={classes.container}>
//         <Box>
//           <Icon
//             className="fh-icon fh-icon-question-mark"
//             sx={{ color: '#f00', fontSize: '64px' }}
//           />
//         </Box>
//         <Box>
//           <Typography variant="sh2">
//             Are you sure to delete this record?
//           </Typography>
//         </Box>
//         <Box>
//           <Typography variant="body3">You can't undo this operation</Typography>
//         </Box>
//         <Box sx={{ marginTop: 2 }}>
//           <Common.Button variant="text" size="small" onClick={handleNo}>
//             No
//           </Common.Button>
//           <Common.Button sx={{ ml: 3 }} size="small" onClick={handleYes}>
//             Yes
//           </Common.Button>
//         </Box>
//       </Box>
//     </Popup>
//   );
// };

// export default DeleteQuestionApi;
import { Box, Icon, Typography } from '@mui/material';
import React, { memo } from 'react';
import ReusablePopup from '../../../../components/ReusablePopup/ReusablePopup';
import { Common } from '../../../../components/common/Common';

const DeleteQuestionPopup = ({ open, onClose, onConfirm }) => {
  const classes = useStyles();
  return (
    <ReusablePopup open={open} onClose={onClose}>
      <Box className={classes.container}>
        <Box>
          <Icon
            className="fh-icon fh-icon-question-mark"
            sx={{ color: '#f00', fontSize: '4rem' }}
          />
        </Box>
        <Box>
          <Typography variant="sh2">
            Are you sure to delete this record?
          </Typography>
        </Box>
        <Box>
          <Typography variant="body3">You can't undo this operation</Typography>
        </Box>
        <Box sx={{ marginTop: 2 }}>
          <Common.Button variant="text" size="small" onClick={onClose}>
            No
          </Common.Button>
          <Common.Button sx={{ ml: 3 }} size="small" onClick={onConfirm}>
            Yes
          </Common.Button>
        </Box>
      </Box>
    </ReusablePopup>
  );
};

export default memo(DeleteQuestionPopup);
